// src/loaders/browser.ts
import localforage from "localforage";
import { log } from "@dxos/log";
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/config/src/loaders/browser.ts";
var CONFIG_ENDPOINT = "/.well-known/dx/config";
var Profile = (_profile = "default") => ({});
var Local = () => {
  return typeof __CONFIG_LOCAL__ !== "undefined" ? __CONFIG_LOCAL__ : {};
};
var Dynamics = async () => {
  const { publicUrl = "", dynamic } = __DXOS_CONFIG__;
  if (!dynamic) {
    log("dynamics disabled", void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 14, S: void 0 });
    return {};
  }
  log("fetching config...", {
    publicUrl
  }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 17, S: void 0 });
  return await fetch(`${publicUrl}${CONFIG_ENDPOINT}`).then((res) => res.json()).catch((error) => {
    log.warn("Failed to fetch dynamic config.", error, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 21, S: void 0 });
    return {};
  });
};
var Envs = (_basePath) => {
  return typeof __CONFIG_ENVS__ !== "undefined" ? __CONFIG_ENVS__ : {};
};
var Defaults = (_basePath) => {
  return typeof __CONFIG_DEFAULTS__ !== "undefined" ? __CONFIG_DEFAULTS__ : {};
};
var Storage = async () => {
  try {
    const config = await localforage.getItem("org.dxos.settings.config");
    if (config) {
      return config;
    }
  } catch (err) {
    log.warn("Failed to load config", {
      err
    }, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 40, S: void 0 });
  }
  return {};
};
var Remote = (target, authenticationToken) => {
  if (!target) {
    return {};
  }
  try {
    const url = new URL(target);
    const protocol = url.protocol.slice(0, -1);
    return {
      runtime: {
        client: {
          // TODO(burdon): Remove vault.html.
          remoteSource: url.origin + (protocol.startsWith("http") ? "/vault.html" : ""),
          remoteSourceAuthenticationToken: authenticationToken
        }
      }
    };
  } catch (err) {
    log.catch(err, void 0, { "~LogMeta": "~LogMeta", F: __dxlog_file, L: 63, S: void 0 });
    return {};
  }
};
export {
  Defaults,
  Dynamics,
  Envs,
  Local,
  Profile,
  Remote,
  Storage
};
//# sourceMappingURL=browser.mjs.map
